import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false;
import router from "./router";
import axios from 'axios'
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);
import { BootstrapVue } from 'bootstrap-vue';
Vue.use(BootstrapVue);

import  'bootstrap';
import "./assets/vendors/css/base/bootstrap.min.css";
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import 'bootstrap-select/dist/js/bootstrap-select.min.js';
import 'bootstrap-select/dist/js/bootstrap-select.min.js';
import 'bootstrap-select/dist/js/i18n/defaults-fa_IR';
import "./assets/vendors/css/base/seenboard-1.0.css";
import './assets/all.css';
import './assets/admin.css';
import './assets/app.css';

Vue.prototype.$siteUrl = 'https://talakhanom.com';
Vue.prototype.$siteName ='طلا خانم';
Vue.prototype.$base_url = '';

window.$ = require('jquery');
import 'jquery-ui/ui/widgets/sortable';

Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('loading', require('./components/Loading').default);
Vue.component('Breadcrumb', require('./components/Breadcrumb').default);
Vue.component('account-status', require('./components/AccountStatus').default);
Vue.component('server-error-message', require('./components/ServerErrorMessage').default);

import PDatePicker from 'vue2-persian-datepicker';
Vue.component('pdatepicker', PDatePicker);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
